import { render, staticRenderFns } from "./selectTemplate.vue?vue&type=template&id=ca16db58&scoped=true&"
import script from "./selectTemplate.vue?vue&type=script&lang=js&"
export * from "./selectTemplate.vue?vue&type=script&lang=js&"
import style0 from "./selectTemplate.vue?vue&type=style&index=0&id=ca16db58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca16db58",
  null
  
)

export default component.exports